export default "__VITE_ASSET__d_I1IhwI__"